import { proxyFetch } from '@ps/functions/utils/proxyFetch';

/** Like a post as the current viewer, via the server-side posts proxy. */
export async function likePost(
  sellerId: string,
  postId: string,
): Promise<void> {
  await proxyFetch('/api/bio/posts/like', {
    method: 'POST',
    body: { storeId: sellerId, postId },
  });
}
